import React from "react"
import BillingHistoryTable from '../../../../utility/table/BillingHistoryTable.jsx'
import SearchBar from "./BillingHistorySearch.jsx";
import { pointLadgerTableData } from "../../Common/Datatable.jsx";
import PointLadgerTable from "../../../../utility/table/PointLadgerTable.jsx";

const PointsLedger = () => {

    const { tableId, ajaxUrl, columns } = pointLadgerTableData;
    return (
        <div className="mb-4 kpi-section">
            <PointLadgerTable tableId={tableId} ajaxUrl={ajaxUrl} columns={columns} />
        </div>
    )
};

export default PointsLedger;